export interface Provider {
  providerName: string;
  logo?: string;
  link: string;
  linkType: string;
}

export interface Eligibility {
  careGroup: string;
  serviceType: string;
  providers: Provider[];
}

export interface VirtualCareState {
  eligibilities: Record<string, Eligibility[]>; // groupNumber -> eligibilities
  setEligibilities: (planToken: string, eligibilities: Eligibility[]) => void;
  clearEligibilities: (planContextIds) => void;
  virtualCareProviders: Eligibility[] | [];
  setVirtualCareProviders: (providers: Eligibility[] | []) => void;
}

export enum VirtualCareStoreKeys {
  ELIGIBILITIES = 'eligibilities',
  SET_ELIGIBILITIES = 'setEligibilities',
  CLEAR_ELIGIBILITIES = 'clearEligibilities',
  VIRTUAL_CARE_PROVIDERS = 'virtualCareProviders',
  SET_VIRTUAL_CARE_PROVIDERS = 'setVirtualCareProviders',
}

export const initialVirtualCareState: VirtualCareState = {
  eligibilities: {},
  setEligibilities: () => {},
  clearEligibilities: () => {},
  virtualCareProviders: [],
  setVirtualCareProviders: () => [],
};
